'use client'

import dynamic from 'next/dynamic'

export function EducatorIntroductionLoader({
  template,
}: {
  template: string | null
}) {
  const EducatorIntroduction = dynamic(
    () =>
      import(`@/components/${template}/home/educator-introduction`).catch(
        () => {
          return Promise.resolve(() => null)
        }
      ),
    { ssr: false }
  )

  return <EducatorIntroduction />
}
